const benignSignalRAbortMarkers = [
  "Handshake was canceled",
  "The connection was stopped during negotiation",
  "The connection was stopped before the hub handshake could complete",
];

/** Aborted SignalR connect (navigation, teardown, or proxy close). Not a user-facing crash. */
export function isBenignSignalRAbort(err: unknown): boolean {
  const message = err instanceof Error ? err.message : String(err);
  return benignSignalRAbortMarkers.some((marker) => message.includes(marker));
}
